module.exports = __webpack_public_path__ + "static/media/ct_logo_white.052e48e3.svg";